import 'Shared/fontawesome-config';
import 'Shared/tailwindcss/tailwind.css';
import './components/wiki-video.css';
import './components/embed.css';
import { createTrackedRoot } from 'Shared/react-mount-tracker';
import { initializeReactQuery } from 'Shared/react-query-initialize';
import { ViewLangIntlProvider } from 'Shared/use_intl';
import { EmbedApp } from './components/EmbedApp';

/**
 * React entry point for the v5 guide embed. Replaces the vanilla-JS/EJS/LESS
 * rendering layer (embed.v5.*.js) in place, behind the same
 * `/Guide/embed/v5/:guideid` route. The PHP shell, the API v2 endpoint, and the
 * Fixbot postMessage bridge are frozen contracts; only the rendering stack
 * changes. Ports the full v5 rendering layer to React + Tailwind (issue #62872):
 * title, intro, steps, per-step video, rail, comments, fullscreen, zoom, and
 * conclusion.
 */
const container = document.querySelector('#embed-root');
if (container) {
   createTrackedRoot(container).render(
      initializeReactQuery(
         <ViewLangIntlProvider>
            <EmbedApp />
         </ViewLangIntlProvider>
      )
   );
}
